import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { USER_DEFAULT_ROUTE } from '@core/constants';
import { SessionState } from '@core/state/shared';
import { Navigate } from '@ngxs/router-plugin';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';

export const isAdminGuard: CanActivateFn = (): Observable<boolean> => {
  const sessionState = inject(SessionState),
    store = inject(Store);

  if (sessionState.isAdmin) {
    return of(true);
  }

  store.dispatch(new Navigate([USER_DEFAULT_ROUTE]));
  return of(false);
};
